import { NullStateCard } from '@hc/component-lib/hclib/components/molecules/null-state-card';
import { STATUSES } from 'legacy/appstore/constants';
import { displayDate } from 'legacy/utils/dates';
import { useListing } from 'legacy/hocs/useListing';
import { ListingRemarks as theme } from 'legacy/css-modules';

const ListingRemarksNullState = () => {
  return (
    <NullStateCard
      theme={theme}
      title="List Remarks Unavailable"
      className={theme.ListingRemarksNullState}
    >
      Listing remarks are unavailable for this property at this time. We are
      working to improve our data each day. Check back later.
    </NullStateCard>
  );
};

const ListingRemarks = ({ addressId }) => {
  const { listing, status } = useListing(addressId);
  const loading = status === STATUSES.INIT || STATUSES.LOADING;
  return (
    <div>
      {loading || listing?.publicRemarks ? (
        listing?.publicRemarks && (
          <>
            {listing?.publicRemarks.split('\n')?.map((p, i) => {
              return (
                <div
                  data-hc-name="property-details-remarks"
                  key={`listing-remark-${i}`}
                  className={theme.Paragraph}
                >
                  {p}
                </div>
              );
            })}
            <div className={theme.ListingRemarksDate}>
              {displayDate(listing?.statusDate)}
            </div>
          </>
        )
      ) : (
        <div className={theme.NullStateContainer}>
          <ListingRemarksNullState />
        </div>
      )}
    </div>
  );
};

export default ListingRemarks;
